import React, { useState, useEffect } from 'react';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { useChatDisplay } from 'src/components/Providers/ChatDisplayProvider';
import { MemberChat } from 'src/remotes/MemberChat';
import { useLocation } from 'react-router-dom';
import { useIsTablet } from '@guildeducationinc/catalog-tools';
import styles from './Chat.module.scss';

export const Chat: React.FC = () => {
	const { userFromIdToken: user, getAccessToken } = useMemberExperienceAuth();
	const { hideChat } = useChatDisplay();
	const location = useLocation();
	const isTablet = useIsTablet();
	const [surveyOffset, setSurveyOffset] = useState<number | undefined>(undefined);

	useEffect(() => {
		const observer = new MutationObserver(() => {
			const surveyElement = document.querySelector('.apptentive-appbar');
			if (surveyElement) {
				setSurveyOffset(surveyElement.clientHeight);
			} else {
				setSurveyOffset(undefined);
			}
		});

		observer.observe(document.body, {
			childList: true, // this watches only direct children of the body, which is where the survey element is appended
		});

		return () => observer.disconnect();
	}, []);

	const calculateOffset = () => {
		if (location.pathname === '/quiz' && isTablet) {
			return 0;
		}
		return surveyOffset;
	};

	return (
		<div className={hideChat && styles.hidden}>
			<MemberChat
				getAccessToken={getAccessToken}
				offset={calculateOffset()}
				product='catalog'
				user={user}
			/>
		</div>
	);
};
